import getConfigEnv from '@brixel-io/brixel-components/dist/configuration/SettingsWebpack';
// supports UA-xxxxxxxxx-x as well as G-xxxxxxxxxx
export default function initGoogleAnalytics() {
    const googleAnalyticsId = getConfigEnv().googleID;
    const scriptId = 'ga-gtag';
    if (document.getElementById(scriptId))
        return;
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = encodeURI('https://www.googletagmanager.com/gtag/js?id=' + googleAnalyticsId);
    document.head.insertBefore(script, null); // inserts as last element
    if (!window.dataLayer) {
        window.dataLayer = [];
    }
    // eslint-disable-next-line prefer-rest-params
    function gtag() { window.dataLayer.push(arguments); }
    // @ts-ignore
    gtag('js', new Date());
    // @ts-ignore
    gtag('config', googleAnalyticsId, {
        anonymize_ip: true, // not necessary when using Google Analytics 4
        linker: {
            domains: ['brixel.pt', 'brixel.io', 'gobrixel.dk', 'gobrixel.se', 'brixel.ch', 'gobrixel.de', 'gobrixel.at', 'gobrixel.nl'],
        },
    });
}
